import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios';

import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import GmapPolygon from 'vue2-google-maps/dist/components/polygon'

Vue.config.productionTip = false

// Google Maps
Vue.use(VueGoogleMaps, {
  load: {
    key: window.app ? 'AIzaSyCPZHtg9I-_DCs6UhY2gcN0OdOayet5hQo' : 'AIzaSyB_uVAfINFohxmR4p8ZTSa0q01OsxHLYSM',
  },
});
Vue.component('GmapMap', VueGoogleMaps.Map);
Vue.component('GmapCluster', GmapCluster);
Vue.component('GmapPolygon', GmapPolygon);

// Vue
const Main = new Vue({
  el: '#vue',
  template: '<App/>',
  router,
  components: {
    'App': App,
    'GmapMap': VueGoogleMaps.Map,
    'GmapCluster': GmapCluster,
    'GmapPolygon': GmapPolygon,
  },
  data: {
    app: window.app ? true : false,
    api_url: location.host.includes('localhost') ? 'http://localhost:5001/big-medium-8abec/us-central1/' : 'https://us-central1-big-medium-8abec.cloudfunctions.net/',
    year: 2024,
    artists: [],
    artistsLoaded: false,
    artistsSchema: {},
    currentPosition: [],
  },
  mounted() {
    if (this.app) {
      document.body.classList.add('app');
      document.oncontextmenu = () => false;
    }
    document.addEventListener('keydown', function keyboardCheck(e) {
      if (e.keyCode === 9) {
        document.body.classList.add('keyboard');
        document.removeEventListener('keydown', keyboardCheck);
      }
    });

    localforage.getItem('participants').then((artistsData) => {
      if (artistsData) {
        JSON.parse(artistsData).forEach(artist => {
          this.artists.push(artist);
          this.artistsLoaded = true;
        });
      }
    });

    this.getParticipants();
    this.getCurrentPosition();
    this.getFieldSchema();

    setInterval(this.checkLastRefresh, 60000);
    setInterval(this.getCurrentPosition, 10000);
    setInterval(this.findDistance, 15000);
  },
  methods: {
    checkLastRefresh() {
      let currentMoment = moment();
      let lastRefresh = moment.unix(localStorage.getItem('lastRefresh'));

      if (currentMoment.diff(lastRefresh, 'minutes') > 60) {
        console.log('Last refresh:', currentMoment.diff(lastRefresh, 'minutes'), 'minutes ago. Refreshing...');
        this.getParticipants();
      }
    },
    async getParticipants() {
      try {
        let response = await axios({
          method: 'GET',
          url: `${this.api_url}getParticipants?year=2024`,
        });

        const participants = response.data.filter(a => a.status === 'Approved');

        localforage.setItem('participants', JSON.stringify(participants));
        localStorage.setItem('lastRefresh', moment().unix());
        this.artists.splice(0, this.artists.length);
        participants.forEach(artist => this.artists.push(artist));
        this.artistsLoaded = true;
        this.findDistance();
      }
      catch (error) {
        alert(error.response.data);
        console.log(error.response.data);
      }
    },
    getCurrentPosition() {
      // Current location is handled by RN for the app
      if (this.app) {
        if (!window.currentPosition || !window.currentPosition.length) return;
        this.currentPosition = window.currentPosition;
      } else {
        navigator.geolocation.getCurrentPosition(position => {
          this.currentPosition = [position.coords.latitude, position.coords.longitude];
        });
      }
    },
    findDistance() {
      if (!this.currentPosition.length) return;
      this.artists.forEach(artist => {
        artist.distance = geolib.getDistance(
          { latitude: this.currentPosition[0], longitude: this.currentPosition[1] },
          { latitude: artist.coordinates.split(',')[0], longitude: artist.coordinates.split(',')[1] }
        )
      });
    },
    async getFieldSchema() {
      let wordpressSchema = await axios({
        method: 'OPTIONS',
        url: `https://admin.austinstudiotour.org/wp-json/wp/v2/participants-${this.year}`,
      });
      this.artistsSchema = wordpressSchema.data.schema.properties.acf.properties;
    },
    openBrowser(url) {
      if ('ReactNativeWebView' in window) {
        window.ReactNativeWebView.postMessage(`openURL|||${url}`);
      } else {
        window.open(url);
      }
    },
  }
});

export default Main;



// WEBPACK FOOTER //
// ./src/main.js